import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class EventToEventEndpoint extends BaseEndpoint {}
